export const COUNTRY_ID_AUSTRALIA = '12';
